import { MetadataSectionTypes } from "types";
import { SET_SELECTED_SECTION } from "./constants";

export const setSelectedSection = (data: MetadataSectionTypes) => {
  return { type: SET_SELECTED_SECTION, data };
};
